var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdiEmoticonHappyOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MDI_emoticon-happy-outline",
    "data-name": "MDI / emoticon-happy-outline",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_emoticon-happy-outline",
    "data-name": "Path / emoticon-happy-outline",
    d: "M20,12a8,8,0,1,0-8,8,8,8,0,0,0,8-8m2,0A10,10,0,1,1,12,2,10,10,0,0,1,22,12M10,9.5A1.5,1.5,0,1,1,8.5,8,1.538,1.538,0,0,1,10,9.5m7,0A1.5,1.5,0,1,1,15.5,8,1.538,1.538,0,0,1,17,9.5m-5,7.73a5.46,5.46,0,0,1-4.19-1.81L9.23,14A3.267,3.267,0,0,0,12,15.23,3.267,3.267,0,0,0,14.77,14l1.42,1.42A5.46,5.46,0,0,1,12,17.23Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiEmoticonHappyOutline);
export default __webpack_public_path__ + "static/media/MDI - emoticon-happy-outline.88f4f0d7ac253ddf040076395e79849d.svg";
export { ForwardRef as ReactComponent };